import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _SecondaryNavBarButton;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { TopNavBar } from '@instructure/ui-top-nav-bar';
import { jsx } from '@instructure/emotion';
import { omitProps } from '@instructure/ui-react-utils';
export var SecondaryNavBarButton = /*#__PURE__*/function (_Component) {
  function SecondaryNavBarButton() {
    _classCallCheck(this, SecondaryNavBarButton);
    return _callSuper(this, SecondaryNavBarButton, arguments);
  }
  _inherits(SecondaryNavBarButton, _Component);
  return _createClass(SecondaryNavBarButton, [{
    key: "render",
    value: function render() {
      return jsx(TopNavBar.Item, Object.assign({
        color: "secondary"
      }, omitProps(this.props, this.constructor.propTypes)), this.props.children);
    }
  }]);
}(Component);
_SecondaryNavBarButton = SecondaryNavBarButton;
_defineProperty(SecondaryNavBarButton, "displayName", 'TopNavBarItem');
_defineProperty(SecondaryNavBarButton, "componentId", "Quizzes".concat(_SecondaryNavBarButton.displayName));
_defineProperty(SecondaryNavBarButton, "propTypes", {
  children: PropTypes.string.isRequired,
  styles: PropTypes.object
});
export default SecondaryNavBarButton;